<template>
  <div class="dhr-list">
    <h4 class="content-subtitle">Assembly</h4>
    <table v-if="data.length > 0" class="detail-table">
      <div class="detail-table-head">
        <span class="medium">N°</span>
        <span class="medium">used</span>
        <span class="large">REF</span>
        <span class="big">Batch</span>
      </div>
      <div class="detail-table-body">
        <div class="body-row" v-for="(part, index) in this.data" :key="index">
          <span class="medium">{{ index }}</span>
          <span class="medium">{{ part.DHRAmount }}</span>
          <span
            class="large"
          >
          <!-- {{ (part.subpartID)? part.subpartID.substr((part.subpartID.indexOf('-') +1)) : part.subPartID.substr((part.subPartID.indexOf('-') +1)) }} -->
          {{part.deviceRef || part.ref}}
          </span>
          <span class="big">{{ part.bonID }}</span>
        </div>
      </div>
    </table>
    <span v-else class="no-data">No subparts available.</span>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    data: Array
  },
  mounted() {
  },
  data() {
    return {
      isLoaded: false
    };
  },
  methods: {},
  watch: {
    data: {
      handler: function() {
        this.isLoaded = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/pages/dhrdetail.scss";

.no-data {
  color: #6a6a6a;
  font-style: italic;
  padding-top: 16px;
}
</style>
